import { createContext } from 'react';

interface PrintScaleValueInterface {
  grid: string;
  metric: boolean;
  orientation: string;
  paperSize: string;
  scale: number | null;
  setGrid(value: string): void;
  setOrientation(value: string): void;
  setPaperSize(value: string): void;
  setPaperDimensionsHeight(value: number): void;
  setPaperDimensionsValid(): void;
  setPaperDimensionsWidth(value: number): void;
  setScale(value: number): void;
}

const PrintContext = createContext<PrintScaleValueInterface | null>(null);

const PrintProvider = PrintContext.Provider;

export { PrintContext, PrintProvider };
